(() => {
    let initProductCarouselSliders = () => {
        $(".product-carousel-section").each(function () {
            if ($(this).hasClass("slider_started")) return;

            $(this).addClass("slider_started");
            let id = $(this).attr("id");
            let slideEl = $(this).find(".swiper-wrapper");
            
            // Data attributes se values uthayen
            let productCount = parseInt(slideEl.data("count")) || 4;
            let productCountMobile = parseInt(slideEl.data("count-mobile")) || 1;

            new Swiper(`#${id} .product-carousel-swiper`, {
                loop: false,
                autoHeight: true,
                allowTouchMove: true,
                lazy: true,
                spaceBetween: 15,
                navigation: {
                    nextEl: `#${id} .swiper-button-next`,
                    prevEl: `#${id} .swiper-button-prev`,
                },
                pagination: {
                    el: `#${id} .swiper-pagination`,
                    clickable: true,
                },
                // --- BREAKPOINTS: Ye asli magic hai ---
                breakpoints: {
                    // 0 se 575px tak (Mobile)
                    0: {
                        slidesPerView: 1, // <--- Yahan 1 karne se mobile par aik hi slide ayegi
                        slidesPerGroup: 1
                    },
                    // 576px se 1099px tak (Tablet)
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    // 1100px aur upar (Desktop)
                    1100: {
                        slidesPerView: productCount,
                        slidesPerGroup: productCount
                    }
                },
                watchSlidesProgress: true,
                preventInteractionOnTransition: true,
                mousewheel: { forceToAxis: true },
            });
        });
    };

    document.addEventListener("shopify:section:load", initProductCarouselSliders);
    initProductCarouselSliders();
})();